import React from 'react';

export const NotificationEmptyIcon = () => {
    return (
        <span key={Math.random()} className="notification-empty-icon">
            <span className="fa-stack fa-3x">
                <i className="fal fa-bell fa-stack-2x text-black-30" />
                <i
                    className="far fa-snooze fa-stack-1x text-black-30"
                    data-fa-transform="shrink-6 right-16 up-12"
                />
                <i
                    className="fas fa-spinner-third fa-stack-1x text-black-30"
                    data-fa-transform="shrink-10 left-4 up-5 rotate-120"
                />
                <i
                    className="fas fa-spinner-third fa-stack-1x text-black-30"
                    data-fa-transform="shrink-10 right-4 up-5 rotate-120"
                />
                <i
                    className="fas fa-circle fa-stack-1x text-black-30"
                    data-fa-transform="shrink-13 down-3"
                />
            </span>
        </span>
    );
};
